export default {
  providersView: {
    title: {
      section: 'PRODUCERS',
      type: {
        QC: 'Available in Quebec',
        ON: 'Available in Ontario',
      },
      goTo: {
        QC: 'Producers available in Quebec',
        ON: 'Producers available in Ontario',
      },
      search: 'Find a provider',
    },
  },
  providerView: {
    label: {
      producerProduct: 'Products',
      relatedArticles: 'related articles',
    },
  },
  providerCard: {
    unavailableContent: 'The provider content is unavailable',
  },
  providerDescription: {
    link: 'Read more',
  },
  filters: {
    label: {
      selectedFilters: 'Filters',
      attributes: 'Attributes',
      countries: 'Countries',
      regions: 'Regions',
      countryRegion: 'Origin',
      all: 'All',
    },
    button: {
      cancel: 'Cancel',
      filter: 'Filter',
    },
  },
};
